/* Product page: gallery, color and size buttons that pick the real Shopify variant. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const root = $('[data-product]');
  if (!root) return;
  const variants = JSON.parse($('#variants-json').textContent);
  const mains = $$('.gallery .main img'), thumbs = $$('.thumbs button');
  const idInput = $('input[name="id"]', root), amt = $('.price .amt', root), addBtn = $('.add', root);

  const showPhoto = i => {
    if (i < 0) return;
    mains.forEach((m, j) => m.classList.toggle('on', i === j));
    thumbs.forEach((b, j) => b.setAttribute('aria-current', i === j ? 'true' : 'false'));
  };
  thumbs.forEach((t, i) => t.addEventListener('click', () => showPhoto(i)));

  const opts = $$('.opt', root);
  const selected = opts.map(o => $('[aria-pressed="true"]', o)?.dataset.value);

  function photoFor(variant, value) {
    if (variant && variant.media) {
      const i = mains.findIndex(m => +m.dataset.mediaId === variant.media);
      if (i >= 0) return i;
    }
    const v = (value || '').toLowerCase();
    return mains.findIndex(m => (m.alt || '').toLowerCase().includes(v));
  }

  function update(changedValue, isColor) {
    const variant = variants.find(v => v.options.every((o, i) => o === selected[i]));
    if (!variant) return;
    idInput.value = variant.id;
    amt.textContent = variant.price;
    addBtn.disabled = !variant.available;
    addBtn.firstChild.textContent = variant.available ? 'Add to cart ' : 'Sold out ';
    if (isColor) showPhoto(photoFor(variant, changedValue));
    const url = new URL(location.href); url.searchParams.set('variant', variant.id);
    history.replaceState(null, '', url);
  }

  opts.forEach((o, pos) => $$('button', o).forEach(b => b.addEventListener('click', () => {
    $$('button', o).forEach(x => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
    selected[pos] = b.dataset.value;
    $('.opt-val', o).textContent = b.dataset.value;
    update(b.dataset.value, o.classList.contains('is-color'));
  })));
})();
